import LabelsView from 'app/scripts/views/label/labels-view';
import View from 'app/scripts/views/internal/view';
import teacup from 'app/scripts/views/internal/teacup-with-helpers';
import ModelCache from 'app/scripts/db/model-cache';
import {
  getOrLoadCardData,
  loadBoardData,
} from 'app/scripts/controller/display-card-loaders';

const t = teacup();

const template = t.renderable(() =>
  t.div(() => {
    t.span('.spinner.centered.js-spinner');

    t.div('.js-labels-view-container');
  }),
);

export class BoardTableCardLabelSelectView extends View {
  initialize() {
    this.viewTitleKey = 'labels';
    this.modelCache = ModelCache;
  }

  async renderLabelsView() {
    const { idCard, onEditSubmit } = this.options;
    this.model = await getOrLoadCardData(idCard);

    await loadBoardData(this.model.get('idBoard'));

    this.labelsView = this.subview(LabelsView, this.model, {
      board: this.model.getBoard(),
      selectLabel: this.toggleLabel.bind(this),
      renderOn: [
        {
          source: this.model.labelList,
          events: 'add remove reset change',
        },
        {
          source: this.model,
          events: 'change:labels, change:idLabels',
        },
      ],
      popOverMethod: 'pushView',
      onEditSubmit: onEditSubmit,
    });

    this.$('.js-spinner').addClass('hide');
    this.ensureSubview(this.labelsView, this.$('.js-labels-view-container'));

    return this;
  }

  render() {
    this.$el.html(template());

    this.renderLabelsView();

    return this;
  }

  toggleLabel(idLabel) {
    this.model.toggleLabel(this.modelCache.get('Label', idLabel));
  }
}
